import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=bcba2988&scoped=true&"
import script from "./Chat.vue?vue&type=script&lang=js&"
export * from "./Chat.vue?vue&type=script&lang=js&"
import style0 from "./Chat.vue?vue&type=style&index=0&id=bcba2988&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../tomokit-guest-app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcba2988",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../tomokit-guest-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VSpacer,VToolbar})
